import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from '../../../data/models/interfaces/user.interface';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  hide = true;
  loading = false;
  profilesInput: string[] = [];
  formRegister: FormGroup = this.fb.group({
    name: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(6)]],
    phone: ['', [Validators.required, Validators.minLength(11), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
    profiles: ['', [Validators.required]],
  });

  //TODO: Atualizado para id
  profiles = ['Diretor', 'Professor', 'Responsável']


  constructor(
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
  }

  onSubmit() {
    const profileInput: string = this.formRegister.value.profiles
    this.loading = true;
    this.profilesInput.push(profileInput)
    const newUser: User = {
      id: '',
      firstName: this.formRegister.value.name,
      lastName: this.formRegister.value.name,
      password: this.formRegister.value.password,
      email: this.formRegister.value.email,
      dtCreated: new Date(),
      phone: this.formRegister.value.phone,
      photo: ' ',
      active: true,
      idsProfiles: this.profilesInput,
    };

  }
}
